import { defa } from 'defa-object';
/**
 * defa.models.UnitFeatureSet
 * The Base UnitFeatureSet object contains any modules this Unit supports.
 * @version 0.9
 */
import Model    from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;

const api = {
	unitFeatureSets: apiHost + '/linkcom',
};

const UnitFeatureSet = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.unitFeatureSets,
	
	defaults: {
		alarm          : null,
		finder         : null,
		generic        : null,
		homeAutomation : null,
		location       : null,
		notifications  : null,
		security       : null,
		settings       : null,
		useBackendApi  : true,
		warmUp         : null,
		wiredAlarmInput: null,
		zone1          : null,
		zone2          : null,
		zone3          : null,
		zone4          : null,
		zone5          : null,
		zone6          : null,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	hasCalendar: function() {
		return this.get('homeAutomation') && this.get('homeAutomation').clusters.masterControl && this.get('homeAutomation').clusters.masterControl.attributes.calendarEntries
	},

	hasMasterControl: function() {
		return this.get('homeAutomation') && this.get('homeAutomation').clusters.masterControl
	},
	
	hasPowerConfiguration() {
		return this.get('homeAutomation') && this.get('homeAutomation').clusters.powerConfiguration
	},

	hasDiyWirelessDevices() {
		return this.get('homeAutomation') && this.get('homeAutomation').clusters.diyWirelessDevices
	},

	hasWiredAlarmInput: function() {
		if( this.isPro() ) {
			return this.get( 'wiredAlarmInput' ) && this.get( 'wiredAlarmInput' ).clusters.iasZone
		}
	},
	
	hasWarmUp: function () {
		return this.get( 'warmUp' );
	},
	
	hasZones: function () {
		return  this.get( 'zone1' ) || this.get( 'zone2' ) || this.get( 'zone3' ) ||
				this.get( 'zone4' ) || this.get( 'zone5' ) || this.get( 'zone6' );
	},
	
	hasSecurity: function () {
		return this.get( 'security' );
	},
	
	hasFinder: function () {
		return this.get( 'finder' );
	},
	
	hasPickupTimes: function () {
		return this.hasWarmUp();
	},
	
	hasAlarm: function () {
		return this.get( 'alarm' );
	},
	
	hasNotifications: function() {
		return this.get( 'notifications' ) || this.get('useBackendApi');
	},
	
	hasWeather: function() {
		return this.get('homeAutomation') || this.get('useBackendApi');
	},

	hasMap: function() {
		return this.hasFinder();
	},
	
	hasWarmupStates: function() {
		return this.hasWarmUp();
	},

	hasSettings: function() {
		return this.get( 'settings' ) || this.get('useBackendApi');
	},

	hasGenericStates: function() {
		return this.get( 'generic' );
	},

	useBackendApi: function() {
		return this.get( 'useBackendApi' );
	},

	hasDayAndNight: function() {
		return this.get('homeAutomation') && this.get('homeAutomation').clusters.masterControl;
	},

	hasTemperatureAlert: function() {
		return this.hasMasterControl() && this.get('homeAutomation').clusters.masterControl.attributes.alarmMask
	},
	
	hasBatteryAlert: function() {
		return this.hasPowerConfiguration() && this.get('homeAutomation').clusters.powerConfiguration.attributes.batteryAlarmMask
	},
	
	hasPowerAlert: function() {
		return this.hasPowerConfiguration() && this.get('homeAutomation').clusters.powerConfiguration.attributes.mainsAlarmMask
	},
	
	hasHeatingSwitch: function() {
		return this.hasMasterControl() && this.get('homeAutomation').clusters.masterControl.attributes.heatingSwitch
	},

	hasAlarmSwitch: function() {
		return this.hasMasterControl() && this.get('homeAutomation').clusters.masterControl.attributes.intrusionSwitch
	},

	hasGeneralAlarmInputSwitch: function() {
		return this.hasWiredAlarmInput() && this.get( 'wiredAlarmInput' ).clusters.iasZone.attributes.alarmMask
	},

	hasFollowMainAlarmSwitch: function() {
		return this.hasWiredAlarmInput() && this.get( 'wiredAlarmInput' ).clusters.iasZone.attributes.followMainIntrusionAlarmSwitch
	},

	hasAccessories: function() {
		return this.hasDiyWirelessDevices()  && this.get('homeAutomation').clusters.diyWirelessDevices.attributes.pairedList
	},

	hasDigiHeat: function() {
		return this.hasDiyWirelessDevices()  && this.get('homeAutomation').clusters.diyWirelessDevices.attributes.digiHeatMode
	},

	isPro: function() {
		return channel.request('units').get(this.get('id')).get('type') === 104;
	},
	
	getZoneId: function(zoneNumber){
		switch ( zoneNumber ) {
			case 1:
				return this.get('zone1').id
			case 2:
				return this.get('zone2').id
			case 3:
				return this.get('zone3').id
			case 4:
				return this.get('zone4').id
			case 5:
				return this.get('zone5').id
			case 6:
				return this.get('zone6').id
			default:
				console.log('Did not recognize zoneNumber: ' + zoneNumber)
		}
	},
	
	getZoneIds: function(){
		let zoneIds = [];
		for(let i = 1; i<=6; i++){
			zoneIds[i] = this.getZoneId(i);
		}
		return zoneIds;
	},

	parse: function( response ) {
		if( response.endpoints ) {
			//All units from backend shall have notifications
			response.endpoints.settings = true;
			response.endpoints.notifications = true;
			response.endpoints.id = this.get( 'id' );
			channel.request( 'unitFeatureSets' ).add(response.endpoints, { merge: true } );
		}
	}
	
} );

export default UnitFeatureSet;